import {join} from '@esgi/ui-kit/utils';
import {PureComponent} from 'react';
import {Body as ModalBody, BodyProps} from '../../body';

import styles from './body.module.less';

export class Body extends PureComponent<BodyProps> {
	public override render() {
		const {className, ...props} = this.props;
		return <ModalBody className={join(styles.alertBody, this.props.className)} {...props}/>;
	}
}

export default Body;
